
import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetail from "../pages/product/page";
import ComparePage from "../pages/compare/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";
import Company from "../pages/company/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:model",
    element: <ProductDetail />,
  },
  {
    path: "/compare",
    element: <ComparePage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
